import { useCallback } from 'react';

import { LANGUAGE_TO_DATE_FORMAT } from '@/constants/date';
import { useCurrentLanguage } from '@/utils/i18n.utils';
import { formatInAppTz } from '@/utils/spain-time';

export function useGetDatetimeRangeFormatted() {
  const language = useCurrentLanguage();
  const dateFormat = LANGUAGE_TO_DATE_FORMAT[language];

  const getDatetimeRangeFormatted = useCallback(
    (startIso: string, endIso: string | null) => {
      const startDatePart = formatInAppTz(startIso, dateFormat);
      const startTime = formatInAppTz(startIso, 'HH:mm');

      if (endIso) {
        const endDatePart = formatInAppTz(endIso, dateFormat);
        const endTime = formatInAppTz(endIso, 'HH:mm');
        return `${startDatePart} ${startTime} - ${endDatePart} ${endTime}`;
      }

      return `${startDatePart} ${startTime} -`;
    },
    [dateFormat]
  );

  return getDatetimeRangeFormatted;
}
